import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { LoginModel } from '../../models/user/login-model';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class LoginService {
  private serviceName = 'api/authentication';
  constructor(private http: Http, public toastr: ToastsManager) {

  }

  authenticateLogin(login: LoginModel) {
    
    return this.http
      .post(`${this.serviceName}/Login`, login, {})
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //getUsers() {
  //  return this.http.get(`${this.serviceName}`)
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}

  //addUser(userModel: User) {

  //  return this.http
  //    .post(`${this.serviceName}/InsertUser`, userModel, {})
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login/login.service.ts